import React from "react"
import { Link } from "react-router-dom"
import Footer from "../components/footer"
import Navbar from "../components/nav"

function JobyneTerms() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="home">
        <div className="container mt-125 mb-50">
          <div className="card-body shadow">
            <h4>Terms & Conditions - Jobyne</h4>
            <br />
            <ul>
              <li>THE DEVELOPER = MWX Apps</li>
              <li>THE APP = Jobyne: US Job Search</li>
              <li>PACKAGE = com.jobyne</li>
            </ul>
            <br />
            <p>
              By downloading or using THE APP, these terms will automatically apply
              to you – you should make sure therefore that you read them carefully
              before using THE APP. You're not allowed to copy, or modify THE APP,
              any part of THE APP, or our trademarks in any way. You're not allowed
              to attempt to extract the source code of THE APP, and you also
              shouldn't try to translate THE APP into other languages, or make
              derivative versions. THE APP itself, and all the trade marks,
              copyright, database rights and other intellectual property rights
              related to it, still belong to THE DEVELOPER.
            </p>
            <p>
              THE DEVELOPER is committed to ensuring that THE APP is as useful and
              efficient as possible. For that reason, we reserve the right to make
              changes to THE APP or to charge for its services, at any time and for
              any reason. We will never charge you for THE APP or its services
              without making it very clear to you exactly what you're paying for.
            </p>

            <br />
            <strong>What Jobyne Does</strong>
            <p>
              Jobyne is a job search application that helps users find job openings
              across the United States. THE APP retrieves <strong>public job
              listings</strong> from third-party job data providers and job boards,
              lets you filter by keyword, location, salary, remote work and job type,
              save jobs, and configure job alerts. When you search, THE APP sends only
              your search keyword and filters via HTTPS and displays the returned
              public listings. Saved jobs, search history and alerts are stored{" "}
              <strong>locally on your device only</strong> and are never stored on our servers.
            </p>
            <p>
              <strong>Third-Party Listings:</strong> Job listings are provided by
              employers and third-party job boards. Jobyne does not create, verify or
              guarantee any job listing. When you tap "Apply," you are redirected to
              the employer's or job board's website or app, and your application is
              governed by that third party's terms and privacy policy.
            </p>

            <br />
            <strong>Eligibility</strong>
            <p>
              THE APP is intended for users who are of legal working age in their
              jurisdiction. If you are under 13, please use it only with parental
              guidance. No account registration is required and we do not knowingly
              collect personal information from children.
            </p>

            <br />
            <strong>License and Permitted Use</strong>
            <p>
              THE DEVELOPER grants you a limited, non-exclusive, non-transferable,
              revocable license to use THE APP on your Android device for personal,
              non-commercial use. You agree NOT to:
            </p>
            <ul>
              <li>Copy, modify, distribute, sell or lease any part of THE APP</li>
              <li>Reverse engineer, decompile or attempt to extract the source code</li>
              <li>Remove or obscure any proprietary notices</li>
              <li>Use THE APP for any illegal or unauthorized purpose</li>
              <li>Attempt to bypass API rate limits or abuse third-party job data providers</li>
              <li>Use bots, scrapers or automated means to harvest job data beyond normal use</li>
              <li>Use THE APP to post fraudulent job listings or misrepresent employers</li>
              <li>Upload viruses, malware or harmful code</li>
            </ul>

            <br />
            <strong>Intellectual Property</strong>
            <p>
              THE APP and its original content, design, features and code are the
              exclusive property of THE DEVELOPER and are protected by copyright and
              trademark laws of Turkey and other countries. Job listing content,
              company names, logos and descriptions belong to their respective owners
              and are displayed for informational purposes. Our trademarks and trade
              dress may not be used without prior written consent.
            </p>

            <br />
            <strong>No Employment Relationship & Job Accuracy Disclaimer</strong>
            <p>
              <strong>IMPORTANT:</strong> Jobyne is a search tool only. We are not an
              employer, recruiter, staffing agency or job board. We do not participate
              in hiring decisions and no employment relationship is created between
              you and THE DEVELOPER by using THE APP.
            </p>
            <p>
              All job listings, salary ranges, descriptions and requirements are
              sourced from third parties. While we strive for freshness and accuracy,
              THE DEVELOPER does not guarantee that listings will be up-to-date,
              accurate, complete or still available. Listings may be expired, duplicated
              or inaccurate. Always verify job details directly with the employer before
              applying, sharing personal information, paying any fee or accepting an offer.
            </p>
            <p>
              <strong>Beware of scams:</strong> Legitimate employers never ask for payment
              to apply or get hired. THE DEVELOPER accepts no liability for any loss,
              direct or indirect, you experience as a result of relying on job listings,
              salary data or communications with third parties found through THE APP.
            </p>

            <br />
            <strong>Third-Party Services</strong>
            <p>
              THE APP uses third-party services to provide job data, distribution
              and advertising:
            </p>
            <ul>
              <li><strong>Third-party job data APIs / job boards</strong> – public job listing providers</li>
              <li><strong>Google Play Services</strong> – https://policies.google.com/terms</li>
              <li><strong>Google AdMob</strong> – serves the ads that keep THE APP free. See <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Google's Advertising Policies</a></li>
            </ul>
            <p>
              Your use of data from these services is subject to their respective
              terms and privacy policies. We have no control over and assume no
              responsibility for their content, availability or practices. THE APP
              does NOT use Google Analytics, Firebase Analytics or Facebook SDK.
            </p>
            <p>
              <strong>Advertising:</strong> Advertising is being introduced in an
              upcoming version of THE APP through Google AdMob. Once enabled, ads
              may be personalised based on your resettable Android Advertising ID
              where you have consented. You can reset or delete this ID at any time
              in <em>Android Settings → Google → Ads</em>, and change your consent
              choice from the app's settings. Full details are in our
              <Link to="/jobyne/privacy-policy" style={{ color: "#0898e7", fontWeight: "600" }}>Privacy Policy</Link>.
            </p>

            <br />
            <strong>Internet and Device Requirements</strong>
            <p>
              Job search requires an active internet connection (Wi-Fi or mobile data).
              THE DEVELOPER cannot take responsibility for THE APP not working at
              full functionality if you lack connectivity or data allowance. If you
              use THE APP outside Wi-Fi, your mobile provider's terms and charges
              apply, including roaming charges. You are responsible for such charges.
            </p>
            <p>
              It's your responsibility to keep your phone and access to THE APP
              secure. We recommend that you do not jailbreak or root your phone, as
              it could make your device vulnerable to malware and cause THE APP to
              malfunction. Keep your device charged – THE DEVELOPER cannot be
              responsible if you cannot access THE APP due to battery loss.
            </p>

            <br />
            <strong>Privacy</strong>
            <p>
              Your privacy is important to us. Our collection and use of information
              is governed by our{" "}
              <a href="/jobyne/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              . By using THE APP you consent to the practices described therein.
              Key points: no personal data collected, only search queries and filters
              are transmitted to job APIs, no tracking, all saved jobs and history
              stored locally.
            </p>

            <br />
            <strong>Disclaimers and Warranties</strong>
            <p>
              THE APP IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
              LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, NON-INFRINGEMENT OR COURSE OF PERFORMANCE. THE
              DEVELOPER does not warrant that THE APP will be uninterrupted,
              error-free, secure or that defects will be corrected.
            </p>

            <br />
            <strong>Limitation of Liability</strong>
            <p>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
              THE DEVELOPER, ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS OR
              AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
              CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF
              PROFITS, DATA, USE, GOODWILL OR OTHER INTANGIBLE LOSSES, RESULTING FROM
              (a) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE APP;
              (b) ANY JOB LISTING OR CONTENT OF ANY THIRD PARTY ON THE APP; (c) ANY
              CONTENT OBTAINED FROM THE APP; (d) UNAUTHORIZED ACCESS OR ALTERATION;
              (e) RELIANCE ON JOB LISTINGS, SALARY DATA OR EMPLOYER COMMUNICATIONS.
            </p>

            <br />
            <strong>Updates and Termination</strong>
            <p>
              At some point, we may wish to update THE APP. THE APP is currently
              available on Android – the requirements for system (and for any
              additional systems we decide to extend the availability of THE APP to)
              may change, and you'll need to download the updates if you want to keep
              using THE APP. THE DEVELOPER does not promise that it will always
              update THE APP so that it is relevant to you and/or works with the
              Android version that you have installed on your device. However, you
              promise to always accept updates to THE APP when offered to you. We may
              also wish to stop providing THE APP, and may terminate use of it at any
              time without giving notice of termination to you. Unless we tell you
              otherwise, upon any termination, (a) the rights and licenses granted to
              you in these terms will end; (b) you must stop using THE APP, and (if
              needed) delete it from your device.
            </p>

            <br />
            <strong>Governing Law</strong>
            <p>
              These Terms shall be governed and construed in accordance with the laws
              of Turkey, without regard to its conflict of law provisions. Any disputes
              shall be submitted to the competent courts of Turkey.
            </p>

            <br />
            <strong id="changes-to-these-terms-and-conditions">
              <a
                aria-hidden="true"
                href="#changes-to-these-terms-and-conditions"
                tabIndex="-1"
              >
                <span className="icon icon-link"></span>
              </a>
              Changes to These Terms and Conditions
            </strong>
            <p>
              We may update our Terms and Conditions from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by updating the "Last Updated" date. These changes
              are effective immediately after they are posted on this page.
              This policy is effective as of September 17, 2026.
            </p>

            <br />
            <strong id="contact-us">
              <a aria-hidden="true" href="#contact-us" tabIndex="-1">
                <span className="icon icon-link"></span>
              </a>
              Contact Us
            </strong>
            <p>
              If you have any questions or suggestions about these Terms and
              Conditions, do not hesitate to contact us at: web-developer@outlook.com
            </p>
            <p className="mt-2"><strong>Developer:</strong> MWX Apps</p>
            <p><strong>App:</strong> Jobyne: US Job Search (com.jobyne)</p>
            <p><strong>Website:</strong> https://mwx-apps.web.app/jobyne</p>
            <p className="mt-2"><em>Jobyne is an independent job search app and is not affiliated with any employer, job board or third-party job data provider.</em></p>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default JobyneTerms